module.exports = function _aperture(n, list) {
  var idx = 0;
  var limit = list.length - (n - 1);
  var acc = new Array(limit >= 0 ? limit : 0);
  while (idx < limit) {
    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
    idx += 1;
  }
  return acc;
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_aperture.js
// module id = ./node_modules/ramda/src/internal/_aperture.js
// module chunks = 54 55 56